import { render, staticRenderFns } from "./add-section-horizontal-banner.vue?vue&type=template&id=09c3b3fc&"
import script from "./add-section-horizontal-banner.vue?vue&type=script&lang=js&"
export * from "./add-section-horizontal-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports